import { styled } from '@linaria/react';

export const Link = styled.a`
  color: inherit;
`;

export const ConditionsRow = styled.div`
  display: flex;
  flex-flow: row;
  gap: 0.3rem;

  align-items: center;
`;

export const ConditionTooltipContent = styled.div`
  min-width: 10rem;
`;
